export default {
  noDataText: 'Nothing has been loaded',
  inputRequired: 'Required field',
  dataIterator: {
    prevPage: 'Previous page',
    nextPage: 'Next page',
    rowsPerPageAll: 'All',
    rowsPerPageText: 'Entries per Page:',
    pageText: '{0}-{1} of {2}',
    noResultsText: 'No matching results'
  },
  dataTable: {
    rowsPerPageText: 'per page'
  },
  roles: {
    noRoles: 'No role',
    student: 'Participant',
    class_guest: 'guest',
    school_guest: 'Guest of community',
    moderator: 'Moderator',
    principal: 'Director',
    school_admin: 'Admin',
    admin: 'Aula-Admin'
  },
  rolesCompound: {
    null: 'No roles',
    noRoles: 'No roles',
    school_student: 'Participant',
    student: 'Participant in {0}',
    class_guest: 'Guest in {0}',
    school_guest: 'Guest of instancce',
    moderator: 'Moderator in {0}',
    principal: 'Director',
    school_admin: 'Admin',
    admin: 'Aula-Admin'
  },
  rolesCompoundWithoutRoom: {
    school_student: 'Participant',
    student: 'Participant',
    class_guest: 'Guest',
    school_guest: 'Guest of instancce',
    moderator: 'Moderator',
    principal: 'Director',
    school_admin: 'Admin',
    admin: 'Aula-Admin'
  },
  Login: {
    'button': 'Login',
    'welcome': 'Welcome!',
    'school': 'Community',
    'login': 'Username',
    'password': 'Password',
    'server': 'Custom server',
    'currentServer': 'Server',
    'update': 'Update',
    'updateServer': 'Enter the URL of a custom server including http or https protocols',
    'updateAlert': 'Please confirm your custom server before proceeding',
    'serverAlert': 'The server could not be reached',
    'password.reminder': 'If you have set your email address, you can reset your password here.',
    'password.reminder.noemail': 'If you forgot your password and have left no email-address, please contact an admin.',
    'passwordError': 'Your username or password are wrong.',
    'showPassword': 'Show Password'
  },
  Footer: {
    'userTerms': 'Terms of use',
    'impressum': 'Imprint'
  },
  Menu: {
    'profileView': 'Show profile',
    'settings': 'Settings',
    'administration': 'Administration',
    'logout': 'Logout'
  },
  Header: {
    'start': 'Start',
    'delegation': 'Delegations'
  },
  Delegation: {
    'delegation.network': 'Delegation network',
    'selected': 'Selected',
    'all.delegation': 'Delegation for all topics',
    'minimum.delegation.number': 'Minimal delegations',
    'user.search': 'User search',
    'noDelegation': 'No delegations in this area.',
    'delegateYourVote': 'Delegate your Vote!'
  },
  Space: {
    'wildIdeas': 'Wild ideas',
    'ideaTopics': 'Topic space',
    'subtitle': 'What should we change?',
    'description': 'You can write down any idea for change that you have. If you support ideas, they have a better chance of going to the topic space and be discussed seriously.',
    'newIdea': 'New idea',
    'ask.on.no.ideas.search.results': 'Create your own idea!',
    'info': 'Look at the ideas others had. Which would you support? Do you have an idea that has not yet been brought up? Write it down!'
  },
  IdeaListing: {
    'sortByAge': 'Date',
    'sortBySupporters': 'Support',
    'sortByName': 'Alphabetically',
    'sortByRandom': 'Random',
    'sortByRecentComments': 'Last commented',
    'sortByFeasibility': 'Feasibility',
    'sortByResult': 'Result',
    'search': 'Search',
    'noIdeas': 'No ideas yet.',
    'ideaSubtitle': 'By {0} on {1}',
    'noComments': 'No suggestions',
    'numComments': '{0} suggestions',
    'noSupporters': 'No supporters',
    'numSupporters': '{0} supporters',
    'isFeasible': 'Feasible',
    'isNotFeasible': 'Not feasible',
    'waitingForFeasibility': 'Idea is being evaluated',
    'resultsPhase': 'Result',
    'votesFor': '{0} in favor',
    'votesAgainst': '{0} against'
  },
  Topic: {
    'topic': 'Topic',
    'goBack': 'Back',
    'info': 'In these topics there are ideas. The topics in Discussion Phase can be discussed, you can add own ideas or suggestions. If the topic is in voting phase, you can vote on the ideas therein.',
    'introTitle': 'These topics are in discussion',
    'introDescription': 'Under each topic there can be multiple ideas that can be discussed and improved before voting.',
    'newTopic': 'New Topic',
    'view.theme': 'Show topic',
    'topic.options': 'Options',
    'edit.topic': 'Edit topic',
    'delete': 'Delete topic',
    'advance.topic.phase': 'Next phase',
    'back.topic.phase': 'Previous phase',
    'to.topic.list': 'Show all topics',
    'allIdeas': 'All ideas',
    'tab.approved.ideas': 'Approved ideas',
    'winnerIdeas': 'Accepted',
    'winnerIdea': 'Accepted',
    'delegates': 'Delegated votes',
    'changeDelegate': 'Change delegation',
    'changeDelegateUnassigned': 'Unassigned',
    'back.phase.limit': "Topic {0} could not be moved back: it’s already in 'Discussion Phase'",
    'phase.change': 'Topic {0} was moved from{1} to {2}',
    'phaseTimeLeft': 'Ends {0}',
    'phaseComplete': 'Time is over. The next phase can be activated by a moderator.',
    'your.delegate': 'Currently voting for you: {0}',
    'cantCreateIdea': 'In this topic, no new ideas can be created.',
    'notFound': 'This topic was not found.',
    'edit': 'Edit topic'
  },
  TopicPhase: {
    'wildIdeas': 'Wild Ideas Phase',
    'edit_topics': 'Discussion Phase',
    'feasibility': 'Approval Phase',
    'vote': 'Voting Phase',
    'finished': 'Results Phase',
    'confirmDialogMessage': 'You are changing the phase for all users for this idea. Information may be lost in the process. Do you really want to continue?'
  },
  TopicCreation: {
    'pageTitleCreating': 'Create topic',
    'pageTitleEditing': 'Edit topic',
    'title': 'What should be the title of the topic?',
    'titleHint': 'z.B. Computer room',
    'description': 'Describtion oft he topic',
    'descriptionHint': 'What do the ideas of this topic have in common?',
    'selectIdeas': 'Chose wild ideas that fit this topic',
    'publish': 'Publish',
    'cancel': 'Cancel',
    'topic.name.empty': 'Title of topic cannot be empty',
    'topic.description.empty': 'Topic describtion cannot be empty',
    'topicNotFound': 'The topic you want to edit could not be found',
    'currentIdeas': 'Current Ideas in this topic'
  },
  IdeaCreation: {
    'title': 'Your idea',
    'titleWithTopic': 'Your idea for the topic "{0}"',
    'name': 'What should your idea be called?',
    'nameExample': 'e.g. buy better computers',
    'suggestion': 'What would you like to suggest?',
    'suggestionDescription': 'You can describe your idea here. Be as precize as possible.',
    'previewShow': 'show preview',
    'selectCategory': 'Does your idea belong to one of these categories?',
    'publish': 'Publish idea',
    'backToTopic': 'Back to topic',
    'yourDelegates': 'Currently voting for you:'
  },
  UserProfile: {
    'unknown': 'unknown',
    'delegate.your.vote': 'Delegate for {0} community',
    'delegates': 'Your delegation for the whole community',
    'remove.delegation': 'Remove delegation for {0}',
    'report': 'Report',
    'profile': 'Profile',
    'edit': 'Edit profile',
    'tab.supported.ideas': 'Created ideas',
    'tab.delegate.for': 'Who am I voting for?',
    'tab.my.delegate': 'Who is voting for me?',
    'report.descripton': 'Here you can report a user for offending behaviour to the moderator team. The team will recieve a notification and will evaluate the content. Please write down why you think the content is offending or against the community rules.',
    'report.title': 'Report',
    'report.question': 'Why do you want to report this user?',
    'report.send': 'Send',
    'delegate.idea': 'Delegation area:',
    'delegates.singular': '{0} vote from {1}',
    'delegates.plural': '{0} votes from {1}'
  },
  SettingsMenu: {
    'personal': 'Personal',
    'password': 'Password',
    'translation': 'Translation',
    'notifications': 'Notifications'
  },
  UserSettings: {
    'email': 'E-mail (optional)',
    'change.password': 'Change password',
    'currentPassword': 'Current password',
    'newPassword': 'New password',
    'newPasswordConfirm': 'Confirm new password',
    'newPasswordConfirmError': 'Passwords do not match',
    'oldPasswordRequired': 'Please fill all password fields.',
    'PasswordRequired': 'Please the password field.',
    'save': 'Save changes'
  },
  NotificationSettings: {
    'allow': 'Notify me...',
    'newSchoolIdea': '...if a new wild idea was posted in school',
    'newClassIdea': '...if a new wild idea was posted in my class',
    'newSugestionYourIdea': '...if anyone has a suggestion for improving your idea',
    'ideaPhaseChange': '...if your idea is in a new phase',
    'schoolTopicPhaseChange': '...if a school-wide subject enters a new phase',
    'classTopicPhaseChange': '...if a topic in your class enters a new phase',
    'receiveDelegatedVote': '...if someone delegates his voice to you',
    'ideaQuorumPassed': '...if your wild idea passes the quorum',
    'votedForYou': '...if someone voted with your vote',
    'votingExpiring': '...if a voting is about to expire.',
    'subjectReport': '...if a subject is reported',
    'voteReceived': '...if your idea received a vote'
  },
  Form: {
    'save': 'Save changes',
    'delete': 'Delete',
    'cancel': 'Cancel',
    'close': 'Close',
    'edit': 'Edit',
    'picture': 'Choose a picture',
    'ok': 'OK',
    'fileSizeExceeded': 'The image is too large with {1} MB, the maximum file size is {0} MB. Please reduce the file size and try again.'
  },
  IdeaCategories: {
    'Regeln': 'Rules',
    'Ausstattung': 'Equipment',
    'Aktivitäten': 'Activities',
    'Aktivatäten': 'Activities',
    'Unterricht': 'Lessons',
    'Meetings': 'Meetings',
    'Zeit': 'Time',
    'Umgebung': 'Environment',
    'Sonstiges': 'Misc'
  },
  Comment: {
    'title': '{0} suggestions sorted by',
    'authorCreated': 'by <b>{0}</b> on {1}',
    'tally': '{0} votes',
    'isDeleted': '[ Suggestion deleted ]',
    'editedBy': 'edited by {0}',
    'sortByNew': 'New',
    'sortByVotes': 'Votes',
    'formTitleEdit': 'Edit suggestion',
    'formTitleCreate': 'New suggestion',
    'formReplyTo': 'Answer to {0}',
    'formLabelTitle': 'Your suggestion',
    'reply': 'Reply',
    'submit': 'Publish',
    'edit': 'Edit',
    'reset': 'Reset',
    'delete': 'Delete',
    'cancel': 'Cancel',
    'snackbarCreated': 'Suggestion published',
    'disabled': 'In this phase, suggestions cannot be made anymore.',
    'add': 'Add suggestion'
  },
  Idea: {
    'idea': 'Idea',
    'wildIdeas': 'Wild Ideas',
    'authorCreated': 'by <b>{0}</b>',
    'votes.pro': '{0} votes',
    'suggestion': 'Suggestion',
    'supporterCount': '<span class="supportNum">{0}</span> by <span class="neededNum">{1}</span>',
    'votesCount': '<span class="supportNum">{0} in favor</span>, <span class="againstNum">{1} against</span>',
    'create.topic': 'Create topic',
    'isPossible': 'Feasible',
    'notPossible': 'Not feasible',
    'feasibilityReason': 'Please explain here, why this idea is not feasible. If it‘s feasible, you can comment or keep this field empty.',
    'statement': 'Publish statement',
    'feasibleDesc': 'What do you want to say?',
    'support': 'Support',
    'noSupport': 'Don‘t support',
    'category': 'This idea belongs tot he category {0}',
    'noCategory': 'This idea does not belong to any category',
    'topicDescription': 'In {0} for Topic',
    'new.suggestion': 'New suggestion',
    'suggestion.author': '{0} on {1}',
    'suggestion.answer': 'Reply',
    'suggestion.report': 'Report',
    'suggestion.edit': 'Edit',
    'suggestion.delete': 'Delete',
    'move': 'Move ideas',
    'back.to.topic': 'Back to topic',
    'ask.first.suggestion': 'Write the first suggestion!',
    'markWinner': 'Mark as "Winner"',
    'unmarkWinner': 'Unmark as "Winner"',
    'notWinner': 'not Winner',
    'voteInFavor': 'In favor',
    'voteAgainst': 'Against',
    'proVotes': 'votes in favor',
    'againstVotes': 'votes against',
    'quorum': 'quorum',
    'delete': 'Delete Idea',
    'feasibilityLabel': 'Feasibility reason'
  },
  IdeaMove: {
    'move.idea.title': 'Move idea',
    'move.question': "Should Idea '{0}' be moved from '{1}'?",
    'move.to.wild.ideas': "To 'Wild Ideas'",
    'move.confirm': 'Move'
  },
  AdminMenu: {
    'title': 'Administration',
    'ideaSpace': 'Rooms',
    'pages': 'Pages',
    'phaseDuration': 'Phase duration',
    'categories': 'Categories',
    'quorum': 'Quorum',
    'holidays': 'Holiday mode',
    'users': 'Groups and users',
    'protocol': 'Protocol',
    'changePhase': 'Change phase',
    'termsOfUse': 'Change terms of use',
    'links': 'Links',
    'roleEdit': 'User Roles'
  },
  AdminLinks: {
    'linkName': 'Name',
    'links': 'Links',
    'linkPosition': 'Position',
    'addLink': 'Add link',
    'linkUrl': 'URL'
  },
  AdminPhaseTime: {
    'phaseWorking': 'How many days should the discussion phase last?',
    'phaseVoting': 'How many days should the voting phase last?',
    'isNotInteger': 'Only integer allowed',
    'days': 'days'
  },
  Category: {
    'category': 'Category',
    'resetFilter': 'Reset'
  },
  AdminCategories: {
    'usageNote': 'Click on current categories, to change their name and description.',
    'deleteHeader': 'Delete category',
    'deleteText': 'Really delete category "{0}"? All matching ideas won’t have a category anymore.',
    'deleteConfirm': 'Delete permanently',
    'deleteCancel': 'Back',
    'snackbarDeleted': 'The category has been deleted',
    'snackbarDeleteFailed': 'The category could not be deleted',
    'titleAdd': 'Add new category',
    'titleEdit': 'Edit category "{0}"',
    'formName': 'Name',
    'position': 'Position',
    'formDescription': 'Description',
    'formPickIcon': 'Chose category-picture',
    'formCreate': 'Create',
    'formSave': 'Save',
    'formReset': 'Reset',
    'formCancel': 'Cancel',
    'snackbarCreated': 'created',
    'snackbarSaved': 'saved',
    'isDefault': 'Default',
    'positionIsNotNumeric': 'The position needs to be numeric'
  },
  AdminQuorum: {
    'school': 'How high should be the community quorum?',
    'class': 'How high should be the room quorum?',
    'schoolPercent': '% of all users on community',
    'classPercent': '% of all users of room'
  },
  AdminHolidays: {
    'description': 'In holiday mode, the following changes apply:',
    'description.1': 'The time till the end of Discussion Phase and Voting Phase is stopped.',
    'description.2': 'Wild ideas cannot be supported.',
    'description.3': 'Noone can vote in Voting Phase',
    'description.4': 'Suggestions cannot be liked.',
    'current.status': 'Current status',
    'normal.status': 'Normal',
    'holiday.status': 'Holiday mode (frozen)',
    'change.status': 'Change status!'
  },
  AdminIdeaSpace: {
    'formIdeaSpace': 'Room',
    'delete': 'Delete room',
    'deleteAlert': 'Careful! Do you really want to delete this room? This will delete all connected user roles, all ideas within, all suggestions, topics, votes and delegations. This action can not be taken back!',
    'formIdeaSpaceName': 'Room name',
    'formIdeaSpaceDescription': 'Description',
    'formIdeaSpaceUrlName': 'Room URL name',
    'add': 'Add room'
  },
  AdminCommunity: {
    'add': 'Add Community',
    'save': 'Save Community',
    'newCommunityName': 'New Community name',
    'community': 'Community',
    'tableHeaderName': 'Name',
    'mainSpaceName': 'Main Ideas space name',
    'impressumEdit': 'Edit Imprint',
    'disableDelegation': 'Disable Delegation?',
    'termsEdit': 'Edit terms of use'
  },
  AdminUsers: {
    'bulkAddUserRole': 'Bulk add user role',
    'bulkRemoveUserRole': 'Bulk remove user role',
    'bulkRemoveUserRoleNoUsers': 'The selected role is not assigned to any user.',
    'bulkRemoveUserRoleCount': 'The selected role will be removed from {0} user(s).',
    'titleAdd': 'Add new user',
    'titleEdit': 'Change user "{0}"',
    'columnHasSetPassword': 'Password reset',
    'columnHasSetPassword-true': 'Yes',
    'columnHasSetPassword-false': 'No',
    'columnActions': '',
    'columnUserRole': 'User role',
    'searchLabel': 'Search',
    'searchNoResults': 'Your search {0} matches no users',
    'formFirstName': 'First name',
    'formLastName': 'Last name',
    'formLogin': 'User name',
    'formLoginSuggestion': 'User name: {0}',
    'formLoginUniqueError': 'There is already a user \'{0}\' in this community. Please enter another name.',
    'formEmail': 'Email (optional)',
    'formGroup': 'Role',
    'formIdeaSpace': 'Room',
    'formAddRole': 'Add role',
    'formNoSpaceSelected': 'not assigned',
    'formRoleRequiresSpace': 'Please choose a role for this room.',
    'formCreate': 'Create',
    'formSave': 'Save',
    'formReset': 'Reset',
    'formCancel': 'Cancel',
    'formClose': 'Close',
    'deleteBulkUsersQuestion': 'Do you really want to delete the selected users permanently?',
    'deleteHeader': 'Delete user',
    'deleteText': 'Do you really want to delete user "{0}"?',
    'deleteConfirm': 'Delete permanently',
    'deleteCancel': 'Back',
    'snackbarCreated': '{0} User created',
    'snackbarSaved': 'User info saved',
    'snackbarDeleted': 'User(s) has been deleted',
    'snackbarRoleAdded': 'Role was added',
    'snackbarRoleDeleted': 'Role was deleted',
    'snackbarDeleteFailed': 'User could not be deleted',
    'snackbarDuplicateGroup': 'This user already has this role.',
    'csvDialog': 'From CSV-file',
    'csvFilePicker': 'Chose file',
    'csvFormatError': 'Please make sure that your file contains all neccessary columns.',
    'csvMissingCellsError': 'Could not load entries, "Vorname" and "Nachname" columns are missing.',
    'csvEncodingError': 'Please make sure that your file was saved as "CSV UTF8"-File.',
    'csvGenericError': 'There was an error loading the CSV file:',
    'loadingStudentsError': 'Please load a table with users first',
    'csvTitle': 'Load from CSV',
    'csvInstructions': 'Here new users can be created from a table. The table should be in the CSV format (with headline) and contain the columns "First name" and "Last name". Optionally you can add the column "Email".',
    'csvReset': 'Reset',
    'csvTableHeader': 'Preview of {0} users',
    'csvSave': 'Save all',
    'csvClose': 'Close',
    'resetPassword': 'Reset password',
    'confirmResetPassword': 'Reset password for user "{0}"?',
    'newPassword': 'New password',
    'usernameExists': 'Username already exists',
    'selectAll': 'select all',
    'unselectAll': 'deselect all',
    'selected': 'selected',
    'selectedUsers': 'Selected users',
    'selectUserRole': 'Select user role',
    'delete': 'delete',
    'addRole': 'add Role',
    'removeRole': 'remove Role',
    'users': 'Users',
    'passwordlist': 'Passwordlist',
    'snackbarAddRole': 'Role has been added',
    'snackbarAddRoleFailed': 'Role could not be added',
    'snackbarRemoveRole': 'Role has been removed',
    'snackbarRemoveRoleFailed': 'Role could not be removed',
    'downloadSampleCSV': 'Download sample file'
  },
  GroupsUsers: {
    add: 'Add User'
  },
  AdminPages: {
    pageName: 'Page name',
    confirmDelete: '"{0}" wirklich delete?',
    add: 'Add page'
  },
  AdminPassList: {
    title: 'Password list',
    selectSpaceLabel: 'Select space',
    selectRoleLabel: 'Select role',
    selectRolePlaceholder: 'All roles',
    buttonPrint: 'Print',
    buttonBack: 'Back',
    labelUsername: 'User name',
    labelPassword: 'Password',
    labelNoPassword: 'Password reset'
  },
  AdminChangePhase: {
    'title': 'Change phases',
    'description.1': 'CAREFUL!',
    'description.2': 'This page allows you to move topics in both directions (to future and past).',
    'description.3': 'This is an experimental feature and could lead to unexpected results.',
    'description.4': 'Please use with cauthion and talk to the responsible moderators.'
  },
  AdminTermsOfUse: {
    'description': 'Please describe your terms of use'
  },
  Snackbar: {
    'close': 'Close',
    'networkError': 'no connection to server',
    'serverError': 'This has not worked.',
    'clientError': 'This has not worked.',
    'rightsError': 'This is not allowed.',
    'formError': 'Please check everything you entered.',
    'missingImage': 'Please add an image to the topic'
  },
  Permissions: {
    'noPermission': 'No permission for this action',
    'idea': {
      'title': 'Idea',
      'create_idea': {
        'title': 'Create idea',
        'description': 'Allows the creation of ideas'
      },
      'delete_idea': {
        'title': 'Delete idea',
        'description': 'Allows the deletion of ideas'
      },
      'support_idea': {
        'title': 'Support idea',
        'description': 'Allows the support of ideas'
      },
      'edit_idea': {
        'title': 'Edit idea',
        'description': 'Allows the editing of other users ideas'
      },
      'approve_idea': {
        'title': 'Approve idea',
        'description': 'Allows the approval of ideas'
      },
      'vote_idea': {
        'title': 'Vote idea',
        'description': 'Allows to vote for ideas'
      },
      'mark_idea_winner': {
        'title': 'Mark idea winner',
        'description': 'Allows to mark an idea as a winner'
      }
    },
    'comment': {
      'title': 'Comment',
      'create_comment': {
        'title': 'Create comment',
        'description': 'Allows the creation of a comment'
      },
      'delete_comment': {
        'title': 'Delete comment',
        'description': 'Allows the deletion of a comment'
      },
      'support_comment': {
        'title': 'Support comment',
        'description': 'Allows the support of a comment'
      },
      'edit_comment': {
        'title': 'Edit comment',
        'description': 'Allows the editing of a comment'
      }
    },
    'topic': {
      'title': 'Topic',
      'create_topic': {
        'title': 'Create topic',
        'description': 'Allows the creation of a topic'
      },
      'edit_topic': {
        'title': 'Edit topic',
        'description': 'Allows the editing of a topic'
      },
      'delete_topic': {
        'title': 'Delete topic',
        'description': 'Allows the deletion of a topic'
      },
      'add_topic_idea': {
        'title': 'Add idea to topic',
        'description': 'Allows the creation of an idea to an existing topic'
      },
      'change_topic_phase': {
        'title': 'Change topic phase',
        'description': 'Allows the editing of the current topic phase'
      }
    },
    'user': {
      'title': 'User',
      'create_user': {
        'title': 'Create user',
        'description': 'Allow the creation of new users'
      },
      'delete_user': {
        'title': 'Delete user',
        'description': 'Allow the deletion of users'
      },
      'edit_user': {
        'title': 'Edit user',
        'description': 'Allow the editing of users'
      }
    },
    'role': {
      'title': 'Role',
      'create_role': {
        'title': 'Create role',
        'description': 'Allows the creation of a new user role'
      },
      'delete_role': {
        'title': 'Delete role',
        'description': 'Allows the deletion of a user role'
      },
      'edit_role': {
        'title': 'Edit role',
        'description': 'Allows the modification of a user role'
      }
    },
    'idea_space': {
      'title': 'Idea space',
      'create_room': {
        'title': 'Create room',
        'description': 'Allows the creation of a new room'
      },
      'delete_room': {
        'title': 'Delete room',
        'description': 'Allows the deletion of a room'
      },
      'edit_room': {
        'title': 'Edit room',
        'description': 'Allows the editing of a room'
      }
    },
    'category': {
      'title': 'Category',
      'create_category': {
        'title': 'Create category',
        'description': 'Allows the creation of a new category'
      },
      'delete_category': {
        'title': 'Delete category',
        'description': 'Allows the deletion of a category'
      },
      'edit_category': {
        'title': 'Edit category',
        'description': 'Allows the modification of a category'
      }
    },
    'admin': {
      'title': 'Admin',
      'see_admin': {
        'title': 'See admin',
        'description': 'Allows a user to see the admin panel'
      }
    },
    'pages': {
      'title': 'Pages',
      'create_page': {
        'title': 'Create page',
        'description': 'Allows the creation of a new page'
      },
      'delete_page': {
        'title': 'Delete page',
        'description': 'Allows the deletion of a page'
      },
      'edit_page': {
        'title': 'Edit page',
        'description': 'Allow the modification of a page'
      }
    }
  },
  RoleEdit: {
    validityTypes: {
      'idea_space': '...selected room',
      'school_and_idea_space': '...main room and selected room',
      'school': '...main room only',
      'all': '...all rooms'
    },
    'userRole': 'User role',
    'userRoleEditTile': 'User roles of {0}',
    'userRoleAssigned': 'Assigned roles',
    'allValidityWarning': 'This user can see all idea spaces, because the assigned role(s) contains a corresponding right.',
    'allValidityAffectedRoles': 'Affected roles: ',
    'assignRole': 'Assign role',
    'saveSuccess': 'Changes successfully saved',
    'saveError': 'An error occurred while saving the changes',
    'createSuccess': 'Role successfully created',
    'createError': 'An error occurred while creating the role',
    'deleteSuccess': 'Role successfully removed',
    'deleteError': 'An error occurred while removing the role',
    'saveChanges': 'Save Changes',
    'deleteRole': 'Delete Role',
    'createRole': 'Create Role',
    'createRoleDialogTitle': 'Create new user role',
    'createRoleDialogLabel': 'Name of the new user role',
    'fetchError': 'An error occurred while loading the roles',
    'validFor': 'Where?'
  },
  Translation: {
    'apply': 'Select Language',
    'translationLanguage': 'Translation Language',
    'selectLanguage': 'Select a translation language',
    'Bulgarian': 'Bulgarian',
    'Chinese': 'Chinese',
    'Czech': 'Czech',
    'Danish': 'Danish',
    'Dutch': 'Dutch',
    'English': 'English',
    'Estonian': 'Estonian',
    'Finnish': 'Finnish',
    'French': 'French',
    'German': 'German',
    'Greek': 'Greek',
    'Hungarian': 'Hungarian',
    'Italian': 'Italian',
    'Japanese': 'Japanese',
    'Lithuanian': 'Lithuanian',
    'Latvian': 'Latvian',
    'Polish': 'Polish',
    'Portuguese': 'Portuguese',
    'Romanian': 'Romanian',
    'Russian': 'Russian',
    'Slovak': 'Slovak',
    'Slovenian': 'Slovenian',
    'Spanish': 'Spanish',
    'Swedish': 'Swedish'
  }
}
